module.exports = __webpack_public_path__ + "static/media/welcome.b6494af5.jpg";